"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React from "react";
import documentsService from "./documents_service";
import IgnoreEntryView from "./ignore_entry_view";
import WaitingSpinner from "../components/waiting_spinner";
class IgnoreEntryWrapper extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      loading: true,
      documentBatch: null,
      error: false
    });
  }
  componentDidMount() {
    documentsService.getUncachedDocumentBatch(this.props.documentBatchId).then(
      (documentBatch) => {
        this.setState({ loading: false, documentBatch });
      },
      () => {
        this.setState({ loading: false, error: true });
      }
    );
  }
  render() {
    if (this.state.loading) {
      return /* @__PURE__ */ React.createElement(WaitingSpinner, { when: true });
    }
    if (this.state.error) {
      return /* @__PURE__ */ React.createElement("div", { className: "error" }, "Could not load the batch to ignore.");
    }
    return /* @__PURE__ */ React.createElement(
      IgnoreEntryView,
      {
        documentBatch: this.state.documentBatch,
        onCancel: this.props.onCancel,
        ignoreEntryComplete: this.props.onComplete
      }
    );
  }
}
export default IgnoreEntryWrapper;
